module.exports = __webpack_public_path__ + "static/img/01911309.40525946.png";